// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconTriangleArrowBottom.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconTriangleArrowBottom = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 7 4" fill="currentColor" { ...props }>
    <path d="M3.5 4L4.37114e-07 -1.27304e-08L7 4.76837e-07L3.5 4Z" />
  </BaseIcon>
);

export default IconTriangleArrowBottom;
